let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iCbfc"), load("8JZKd"), load("kTv6A"), load("gLGsg"), load("3YiRE")]).then(() => parcelRequire('iR5x9'));